import { useEffect, useRef } from 'react';

function NewDynamicBackground({ variant = 1 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const headerHeight = 64;

    const drawShapes = () => {
      const w = window.innerWidth;
      const h = window.innerHeight; // viewport height, triangle at bottom of visible area

      canvas.width = w;
      canvas.height = h;

      ctx.clearRect(0, 0, w, h);

      const drawCircle = (x, y, r) => {
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fillStyle = '#ffdd19';
        ctx.fill();
      };

      const drawTriangle = (points) => {
        ctx.beginPath();
        ctx.moveTo(points[0][0], points[0][1]);
        ctx.lineTo(points[1][0], points[1][1]);
        ctx.lineTo(points[2][0], points[2][1]);
        ctx.closePath();
        ctx.fillStyle = '#e61b21';
        ctx.fill();
      };

switch (variant) {
      case 1:
        drawCircle(-w * 0.12, headerHeight + w * 0.12, w * 0.25);
        drawTriangle([
          [w, h],
          [w - w * 0.18, h],
          [w, h - w * 0.18],
        ]);
        break;

      case 2:
        drawCircle(-w * 0.05, headerHeight + w * 0.1, w * 0.15);
        drawTriangle([
          [w, h * 0.85],
          [w - w * 0.15, h],
          [w, h],
        ]);
        break;

      case 3:
        drawCircle(-w * 0.08, headerHeight + w * 0.0, w * 0.3);
        drawTriangle([
          [w, h],
          [w - w * 0.18, h],
          [w, h - w * 0.35],
        ]);
        break;

      case 4:
        drawCircle(-w * 0.3, headerHeight + w * 0.18, w * 0.4);
        drawTriangle([
          [w, h],
          [w - Math.min(w * 0.15, w * 0.5), h],
          [w, h - Math.min(h * 0.35, 100)],
        ]);
        break;

      case 5:
        drawCircle(-w * 0.15, headerHeight + w * 0.2, w * 0.55);
        drawTriangle([
          [w, h],
          [w - w * 0.58, h],
          [w, h - w * 0.48],
        ]);
        break;

        // The Fix: Add this default case
        default:
          break;
    }

    };

    drawShapes();
    window.addEventListener('resize', drawShapes);
    return () => window.removeEventListener('resize', drawShapes);
  }, [variant]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed', // stays behind content
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        pointerEvents: 'none',
      }}
    />
  );
}

export default NewDynamicBackground;
